'use client';

import { Product, ProductType } from '@interface/product';
import ROUTES from '@utils/routes';
import { useAddProductHandler } from 'app/hooks/useAddProductHandler';
import { useSessionStore } from 'app/stores/globalStore';
import { Button } from 'designSystem/Buttons/Buttons';

export default function ProductSelectorButton({
  product,
  className = '',
  disableClientData = true,
  ctaLanding = false,
}: {
  product: Product;
  className?: string;
  disableClientData?: boolean;
  ctaLanding?: boolean;
}) {
  const addProductHandler = useAddProductHandler({ isDashboard: false });
  const { cleanCheckoutSession } = useSessionStore(state => state);

  if (ctaLanding) {
    return (
      <Button
        href="#leadFormLanding"
        size="lg"
        type="primary"
        className={`mb-6 md:mb-0 md:mt-auto ${className}`}
        id="tmevent_click_book_anchor_button"
      >
        Asesoramiento Gratuito
      </Button>
    );
  }
  if (product.type == ProductType.Surgery) {
    return (
      <a href={ROUTES.checkout.clinics}>
        <Button
          size="lg"
          type="primary"
          className={`mb-6 md:mb-0 md:mt-auto ${className}`}
          id="tmevent_click_book_anchor_button"
        >
          Agenda tu consulta
        </Button>
      </a>
    );
  }
  return (
    <Button
      onClick={() => {
        cleanCheckoutSession(disableClientData);
        addProductHandler(product);
      }}
      size="lg"
      type="primary"
      className={`mb-6 md:mb-0 md:mt-auto ${className}`}
      id="tmevent_click_book_anchor_button"
    >
      Me interesa
    </Button>
  );
}
